(ns app.front.form.util)


(def added-field-class "p-4 rounded-md bg-green-200")
(def removed-field-class "p-4 rounded-md bg-red-200")
(def changes-field-class "p-4 rounded-md bg-yellow-200")
(defn changes-class [type]
  (case type
    :- removed-field-class
    :+ added-field-class
    :r changes-field-class
    :s changes-field-class))
